function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  d: "M26.39 26.343c.907-.889 2.36-.889 3.267 0l7.013 7.014a2.333 2.333 0 0 1-.013 3.3l-.014.013a2.333 2.333 0 0 1-3.3-.013l-3.01-3.034v13.044a2.333 2.333 0 1 1-4.666 0v-13.16L22.61 36.47a2.333 2.333 0 1 1-3.22-3.36zm-2.969-18.66c7.307-2.53 15.28 1.344 17.809 8.65l.377.053a11.667 11.667 0 0 1 6.046 2.903c4.762 4.34 5.104 11.719.764 16.481l-.126.132a2.333 2.333 0 0 1-1.624.661l-.189-.008a2.333 2.333 0 0 1-1.351-.575l-.011-.01-.01-.009a2.333 2.333 0 0 1-.19-3.294l.2-.232A7 7 0 0 0 39.665 21h-.14a2.333 2.333 0 0 1-2.333-1.867l-.063-.288a9.333 9.333 0 0 0-18.23.288l-.04.163A2.333 2.333 0 0 1 16.568 21h-.234a7 7 0 0 0-5.25 11.667l.131.114a2.333 2.333 0 1 1-3.63 2.849l-.252-.293a11.667 11.667 0 0 1-2.577-5.892C3.9 23.06 8.384 17.19 14.77 16.333l.125-.345a14 14 0 0 1 8.526-8.306z"
});

var SvgLine = function SvgLine(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 56 56",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLine, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/line.2e997a20.svg";
export { ForwardRef as ReactComponent };